// src/ui/organisms/ProductInfo/view.js
import { useState, useEffect } from 'react';
import { BiPackage, BiHash, BiDollarCircle, BiLayer, BiCopy, BiShow, BiBox } from 'react-icons/bi';
import ModalBtn from '../../molecules/modalButton/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { formatMoney } from '../../../utils/formating';
import './style.css';

function ProductInfo({ data }) {
    const [product, setProduct] = useState({});

    useEffect(() => {
        setProduct(data?.product || {});
    }, [data?.product]);

    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            dispatchCustomEvent("popup", { message: "Copiado al portapapeles", type: "success" })
        }).catch(err => {
            console.error('Error al copiar: ', err);
        });
    };

    const InfoRow = ({ icon: Icon, label, value, showCopy = true, isMoney = false }) => {
        if (value === undefined || value === null) return null;
        const displayValue = isMoney ? formatMoney(value) : value;

        return (
            <div className="product-info-row">
                <div className="product-info-left">
                    <Icon className="product-info-icon" />
                    <span className="product-info-label">{label}:</span>
                    <span className="product-info-value">{displayValue}</span>
                </div>
                {showCopy && (
                    <button className="product-copy-btn" onClick={() => copyToClipboard(displayValue)} title="Copiar">
                        <BiCopy />
                    </button>
                )}
            </div>
        );
    };

    return (
        <ModalBtn
            id={"saw-product-" + data?.note_id + "-" + data?.product_id}
            title={<BiShow />}
            type="action"
            disabled={!data?.product_id}
        >
            <div className="product-detail-card">
                <div className="product-card-header">
                    <div className="product-avatar-container">
                        <BiBox className="product-avatar-icon" />
                    </div>
                    <div className="header-text">
                        <h2 className="product-name">{product?.name || 'Producto sin nombre'}</h2>
                        <span className="product-type-badge">ARTÍCULO DE INVENTARIO</span>
                    </div>
                </div>

                <div className="product-info-list product-scroll-area">
                    <InfoRow icon={BiHash} label="SKU / Referencia" value={product?.sku || 'N/A'} />
                    <InfoRow icon={BiDollarCircle} label="Precio de Venta" value={product?.value} isMoney={true} />
                    <InfoRow icon={BiLayer} label="Stock Actual" value={product?.stock} showCopy={false} />

                    <div className="product-meta-info">
                        <BiPackage />
                        <span>Información técnica del producto</span>
                    </div>
                </div>
            </div>
        </ModalBtn>
    );
}

export default ProductInfo;
